import { Grid, Typography, Box } from "@mui/material";

import { formatNumberToUSD } from '@finpay-development/shared-platform/lib/esm/shared/calculators';
import { PatientEncounter } from "@finpay-development/shared-platform/lib/esm/patient/components/models/patient-encounter";
import { DetailedLedger } from "@finpay-development/shared-platform/lib/esm/shared/model/ledger";

interface PfrDownPaymentAmtProps {
    selectedEncounter: PatientEncounter;
    labelPadding?: number;
    amountMargin: number;
    amountPadding: number;
}

export function PfrDownPaymentAmt(props: PfrDownPaymentAmtProps) {
    const {selectedEncounter, labelPadding, amountMargin, amountPadding} = props;
    const pfrPendingBalance = selectedEncounter?.patientPaymentProgram?.[0]?.patientPaymentSchedule?.pfrPendingBalance;
    const pfrAmt = selectedEncounter?.adjustedPfrAmt ? selectedEncounter?.adjustedPfrAmt : selectedEncounter?.pfrAmt
    const downPaymentsPaid = pfrAmt - pfrPendingBalance;
    
    return (
        <>
            <Grid item xs={8} style={{ paddingTop: labelPadding ? `${labelPadding}px` : undefined }}>
                <Typography variant="subtitle2">
                    Down Payment Taken
                </Typography>
            </Grid>
            <Box justifyContent="flex-end" className="pr-1 mt-2" style={{ marginTop: `${amountMargin}px`, paddingTop: `${amountPadding}px` }}>
                <Grid item xs={4}>
                    <Typography variant="subtitle2">
                        <span test-id="down-payment-taken-amount">{formatNumberToUSD(downPaymentsPaid)}</span>
                    </Typography>
                </Grid>
            </Box>
        </>
    )
}